"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var Checkbox_style_1 = __importDefault(require("./Checkbox.style"));
var Checkbox = (0, react_1.forwardRef)(function (_a, ref) {
    var checked = _a.checked, value = _a.value, children = _a.children, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, id = _a.id, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, rest = __rest(_a, ["checked", "value", "children", "className", "defaultChecked", "disabled", "id", "label", "name", "onBlur", "onChange", "onFocus"]);
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: id, className: className, css: (0, Checkbox_style_1.default)(disabled || false) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ id: id, ref: ref, name: name, type: 'checkbox', checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: onFocus, onBlur: onBlur, value: value }, rest)), label, children] })));
});
Checkbox.displayName = 'PrezzeeCheckbox';
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map